import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { AuthService } from '../core/auth.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";
import { CategoryInfoRequest } from "./../../models/inventory/category-info-request";
import { CurrencyService } from "../cms/currency.service";
import { LanguageService } from '../cms/language.service';
import { ShoppingCartService } from '../inventory/shopping-cart.service';


@Injectable()
export class CategoryService {
  
  constructor
  (
    public _api: ApiService, 
    public _cache: CacheService,
    public currencyService: CurrencyService,
    private mappings: Mappings, 
    private authService: AuthService,
    private languageService: LanguageService,
    public ShoppingCartService: ShoppingCartService
  ) {}

  getCategory(categoryId: number, lang: string) {
    
    //Reading userId
    let customerId = this.authService.getCurrentUserId();   
    let curr = this.currencyService.getCurrency();
    let cartId = this.ShoppingCartService.getCartId();
    let templateBuilderId: string = this.authService.getTemplBuilderId();

    let url = this.mappings.Web_Api_Get_Category_Details
    .replace('{categoryId}', categoryId.toString())
    .replace('{lang}', lang)
    .replace('{customerid}', customerId)
    .replace('{currency}', curr)
    .replace('{cartid}', cartId)
    .replace('{templatebuilderid}', templateBuilderId);
    
    let key = url;

    return this._api.get(url);
  }

  getCatalogCategoriesData(lang: string) {
    let cartId = this.ShoppingCartService.getCartId();
    let curr = this.currencyService.getCurrency();
    let customerId = this.authService.getCurrentUserId();   
    let url = this.mappings.Web_Api_Get_Catalog_Categories_Data.replace('{lang}', lang).replace('{currency}', curr).replace('{userid}', customerId).replace('{cartid}', cartId);
    let key = url;

    return this._api.get(url);
  }

  getCategoryByUrl(lang: string, seoUrl: string) {

    //Reading userId
    let customerId = this.authService.GetUserId();    
    let curr = this.currencyService.getCurrency();
    let cartId = this.ShoppingCartService.getCartId();
    let templateBuilderId: string = this.authService.getTemplBuilderId();

    let url = this.mappings.Web_Api_Get_Category_By_Url
    .replace('{lang}', lang)
    .replace('{customerid}', customerId)
    .replace('{currency}', curr)
    .replace('{seoUrl}', seoUrl)
    .replace('{cartid}', cartId)
    .replace('{templatebuilderid}', templateBuilderId);
    
    let key = url;

    return this._api.get(url);
  }

  getCategoryInfo(parameters: CategoryInfoRequest) 
  {
    return this._api.post(this.mappings.Web_Api_Post_Send_Category_Info_Request, parameters)
  }

  getCategoryPriceData(categoryId: number) {
    
    //Reading userId
    let customerId = this.authService.getCurrentUserId();   
    let curr = this.currencyService.getCurrency();
    let lang = this.languageService.getLongLang();

    let url = this.mappings.Web_Api_Get_Catalog_Categories_Price_Data
    .replace('{categoryId}', categoryId.toString())
    .replace('{customerid}', customerId)    
    .replace('{lang}', lang)
    .replace('{currency}', curr);

    return this._api.get(url);
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/inventory/category.service.ts